import {

  DocumentText1,
  Logout,

  Profile,
  SearchNormal1,
  Setting2,
} from "iconsax-react";
import React from "react";
import { BiGridAlt } from "react-icons/bi";

import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { clearUserData } from "../utils/LSSB_live";

const Sidebar = ({ isSidebarOpen, onClose }) => {
  const router = useLocation();

  return (
    <div
      className={` lg:block lg:relative ${
        isSidebarOpen ? "block z-20 fixed inset-0 transition-opacity" : "hidden"
      }`}
    >
      <div
        onClick={onClose}
        className="fixed inset-0 bg-[#29292980]  transition-opacity lg:relative"
      ></div>
      <div className="absolute top-0 right-0 -ml-8 flex pt-4 pr-2 sm:-ml-10 sm:pr-4">
        <button
          onClick={onClose}
          type="button"
          className="rounded-md text-gray-700 hover:text-[white] focus:outline-none focus:ring-2 focus:ring-[white]"
        >
          <span className="sr-only">Close panel</span>

          <svg
            className="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
             strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div className="w-[210px] md:w-[242px]  min-h-screen bg-[#F6F6F6] border-r pt-[32px] pb-7 sticky top-0  ">
        <div className="flex gap-[16px] items-center px-[16px] md:px-[26px] mb-[32px] md:mb-[48px] ">
          <img
            src="./asset/lssbLogo.png"
            alt="logo"
            className="h-[40px] w-[40px]"
          />
          <div>
            <p className="text-sm  md:text-base text-[#202430] font-medium md:font-semibold leading-[20px]">
              Lagos State
            </p>
            <p className="text-sm  md:text-base text-[#202430] font-medium md:font-semibold leading-[20px]">
              Scholarship Board
            </p>
          </div>
        </div>
        <div className="border-b pb-[32px] mb-[32px] border-[#CCCCF5]">
          <Link
            onClick={onClose}
            to="/dashboard"
            className="flex gap-2 items-center mr-2"
          >
            <div
              className={`${
                window.location.pathname === "/dashboard" ? "block" : "hidden"
              } h-[32px] bg-[#AF8544]  w-[4px] `}
            ></div>
            <div
              className={`w-full   py-[12px] pl-[17px] items-center  flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[16px] ${
                window.location.pathname === "/dashboard"
                  ? "  text-[#002240] bg-[#E9EBFD] "
                  : "text-[#718096] ml-[12px]"
              }`}
            >
              <BiGridAlt size="20" className="text-[19px] md:text-[24px] " />
              <div>Dashboard</div>
            </div>
          </Link>
          <Link
            to="/grants"
            onClick={onClose}
            className="flex gap-2 items-center mr-2"
          >
            <div
              className={`${
                window.location.pathname === "/grants" ||
                window.location.pathname === "/register"
                  ? "block"
                  : "hidden"
              } h-[32px] bg-[#AF8544]  w-[4px] `}
            ></div>
            <div
              className={`w-full   py-[12px] pl-[17px] items-center  flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[16px] ${
                window.location.pathname === "/grants" ||
                window.location.pathname === "/register"
                  ? "  text-[#002240] bg-[#E9EBFD] "
                  : "text-[#718096] ml-[12px]"
              }`}
            >
              <SearchNormal1 size="20" className="text-[19px] md:text-[24px] " />
              <div>Award/Grant</div>
            </div>
          </Link>
          {/* <Link to="/notification" className="flex gap-2 items-center mr-2">
            <div
              className={`${
                window.location.pathname === "/notification"
                  ? "block"
                  : "hidden"
              } h-[32px] bg-[#AF8544]  w-[4px] `}
            ></div>
            <div
              className={`w-full   py-[12px]  pl-[17px] flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[21px] ${
                window.location.pathname === "/notification"
                  ? "  text-[#002240] bg-[#E9EBFD] "
                  : "text-[#718096] ml-[12px]"
              }`}
            >
              <MessageText1 size="24" />
              <div>Notification</div>
            </div>
          </Link> */}
          <Link
            to="/myapplication"
            onClick={onClose}
            className="flex gap-2 items-center mr-2"
          >
            <div
              className={`${
                window.location.pathname === "/myapplication"
                  ? "block"
                  : "hidden"
              } h-[32px] bg-[#AF8544]  w-[4px] `}
            ></div>
            <div
              className={`w-full   py-[12px] pl-[17px] items-center  flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[16px] ${
                window.location.pathname === "/myapplication"
                  ? "  text-[#002240] bg-[#E9EBFD] "
                  : "text-[#718096] ml-[12px]"
              }`}
            >
              <DocumentText1 size="20" className="text-[19px] md:text-[24px] " />
              <div>My Application</div>
            </div>
          </Link>
         
      
          <Link
            to="/myprofile"
            onClick={onClose}
            className="flex gap-2 items-center mr-2"
          >
            <div
              className={`${
                window.location.pathname === "/myprofile" ? "block" : "hidden"
              } h-[32px] bg-[#AF8544]  w-[4px] `}
            ></div>
            <div
              className={`w-full   py-[12px]  pl-[17px] flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[21px] ${
                window.location.pathname === "/myprofile"
                  ? "  text-[#002240] bg-[#E9EBFD] "
                  : "text-[#718096] ml-[12px]"
              }`}
            >
              <Profile size="20" className="text-[19px] md:text-[24px] " />
              <div>My Profile</div>
            </div>
          </Link>
        </div>
        <Link
          to="/settings"
          onClick={onClose}
          className="flex gap-2 items-center mr-2"
        >
          <div
            className={`${
              window.location.pathname === "/settings"
                ? "block"
                : "hidden"
            } h-[32px] bg-[#AF8544]  w-[4px] `}
          ></div>
          <div
            className={`w-full   py-[12px]  pl-[17px] flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[21px] ${
              window.location.pathname === "/settings"
                ? "  text-[#002240] bg-[#E9EBFD] "
                : "text-[#718096] ml-[12px]"
            }`}
          >
            <Setting2 size="20" />
            <div>Settings</div>
          </div>
        </Link>

        <button
          onClick={clearUserData}
          className="flex gap-2 items-center mr-2"
        >
          <Link to="/login">
            <div
              className={`w-full   py-[12px]  pl-[17px] flex tracking-[0.2px] gap-[12px] font-medium text-[14px] leading-[21px] ${
                window.location.pathname === ""
                  ? "  text-[#002240] bg-[#E9EBFD] "
                  : "text-[#718096] ml-[12px]"
              }`}
            >
              <Logout size="20" className="text-[19px] md:text-[24px] " />
              <div>Log out</div>
            </div>
          </Link>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
